import { render, staticRenderFns } from "./Machining.vue?vue&type=template&id=28c1272b&"
import script from "./Machining.vue?vue&type=script&lang=js&"
export * from "./Machining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports